import React from "react";
import "./Light_Gray_Btn.css";
import { Button } from "react-bootstrap";

function Light_Gray_Btn({btnText,onClick}) {
  return (
    <>
      <section className="Light_Gray_Btn_holder">
        <Button className="Light_Gray_Btn" onClick={onClick}>{btnText}</Button>
      </section>
    </>
  );
}

export default Light_Gray_Btn;
